// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '90f3de39493b1c616f77188dc7a338280458ab8f';
export const BUILD_NUMBER = '258';
export const BUILD_TIMESTAMP = '2026-10-05T07:00:47.114Z';
